import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import i18n from "../i18n"; // i18n 인스턴스를 가져옴

Vue.use(VueRouter);

const routes = [
  {
    path: "/poster",
    name: "Home",
    redirect: "/poster/ko",
  },
  {
    path: "/poster/:lang",
    component: Home,
    beforeEnter: (to, from, next) => {
      const lang = to.params.lang;
      if (["ko", "en"].includes(lang)) {
        next();
      } else {
        next("/poster/ko");
      }
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const lang = to.params.lang;
  if (i18n.locale !== lang) {
    i18n.locale = lang;
  }
  next();
});

export default router;
